// extracted by mini-css-extract-plugin
export default {"btn":"Buttons_btn__E06yD","btn_container":"Buttons_btn_container__mgjpL"};